<header>
  @if (environment.showEnvironmentInformation) {
    <core-environment-information />
  }

  <core-navbar
    (toggleSideBarEvent)="toggleSidebar()"
    [hasSideBar]="true"
    [loading]="false"
  />
</header>
